import React, { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

export function itemInitials(name) {
  if (typeof name !== "string") return "•";
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "•";
  return words.slice(0, 2).map((word) => word[0]).join("").toUpperCase();
}

export default function ItemImage({ src, name, className = "", fallbackClassName = "" }) {
  const [failed, setFailed] = useState(!src);
  useEffect(() => setFailed(!src), [src]);
  if (failed) return <div role="img" aria-label={`${typeof name === "string" && name.trim() ? name.trim() : "Item"} image placeholder`} className={cn("grid place-items-center bg-bg-elevated text-ink-secondary font-display font-semibold", className, fallbackClassName)} data-testid="item-image-fallback">{itemInitials(name)}</div>;
  return <img src={src} alt={`${typeof name === "string" && name.trim() ? name.trim() : "Item"}`} className={className} onError={() => setFailed(true)} />;
}
